var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "id": "dashboard"
    }
  }, [_c('h2', {
    staticClass: "mo"
  }, [_vm._v("단비 내린 챗봇 "), _c('br'), _vm._v(_vm._s(_vm.totalChatbotCount) + "개!!!")]), _vm._v(" "), _c('h2', {
    staticClass: "pc"
  }, [_vm._v("단비 내린 챗봇 " + _vm._s(_vm.totalChatbotCount) + " 개!!!")])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ad983d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/landingdashboard.vue
// module id = 383
// module chunks = 0